import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { viewLoading } from "../../utils/loading";
import { apiError, getCustodianSuccess } from "./actions";
import { SET_PREVIEW_CUSTODIAN } from "./actionTypes";
import { getManagement } from "../../apis/tax-portal";

function* getPreviewCustodian({ payload: custodianIdx }) {
  if (custodianIdx) {
    viewLoading(true);
    try {
      const response = yield call(getManagement, custodianIdx);
      yield put(getCustodianSuccess(response));
    } catch (error) {
      yield put(apiError(error));
    }
    viewLoading(false);
  } else {
    yield put(getCustodianSuccess(null));
  }
}


function* watchGetPreviewCustodian() {
  yield takeEvery(SET_PREVIEW_CUSTODIAN, getPreviewCustodian);
}

function* SerachPersonSaga() {
  yield all([
    fork(watchGetPreviewCustodian),
  ]);
}

export default SerachPersonSaga;